import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Table,
	Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";
import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";

// import "../app-invoice.css";
import { getSRQDocReport } from "../../../store/Reports/actions";
import LoadingModel from "../../LoadingModel";

class QuotationReportDocument extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.getSRQDocReport(
			this.props.match.params.id,
			this.props.SRQuotationPdf
		);
	}
	// getPDFReport() {
	//   //	297 x 210 mm
	//   const codewidth = document.getElementById("toPdf").style.width;
	//   document.getElementById("toPdf").style.width = "297mm";
	//   const doc = new jsPDF("l", "mm", [297, 210]);
	//   doc.setDisplayMode(1);
	//   doc.html(document.getElementById("toPdf"), {
	//     callback: function (doc) {
	//       doc.save();
	//       document.getElementById("toPdf").style.width = codewidth;
	//     },
	//     x: 0,
	//     y: 0,
	//     html2canvas: { scale: 0.25 },
	//   });
	// }

	getPDFReport = async () => {
		const element = document.getElementById("toPdf");
		if (!element) return;

		const originalWidth = element.style.width;
		element.style.width = "297mm";
		element.style.maxWidth = "290mm";

		const pdf = new jsPDF("p", "mm", "a4");
		const pageWidth = pdf.internal.pageSize.getWidth();
		const pageHeight = pdf.internal.pageSize.getHeight();

		// Use a higher scale for better text clarity
		const canvas = await html2canvas(element, {
			scale: 3,
			useCORS: true,
			scrollX: 0,
			scrollY: 0,
			windowWidth: element.scrollWidth,
			windowHeight: element.scrollHeight,
		});

		const imgData = canvas.toDataURL("image/png");
		const imgWidth = pageWidth;
		const imgHeight = (canvas.height * imgWidth) / canvas.width;

		let heightLeft = imgHeight;
		let position = 0;

		pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
		heightLeft -= pageHeight;

		while (heightLeft > 0) {
			position -= pageHeight;
			pdf.addPage();
			pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;
		}

		pdf.save("Service_Quotation.pdf");

		// Revert back to original
		element.style.width = originalWidth;
	};
	reportBody() {
		return (
			<Row className="p-1 report-preview">
				<Col md={12} className="p-1">
					<Card className="p-1 report-preview-card">
						<CardBody className="report-padding pb-0">
							<div className="report-body flex-sm-row flex-column  mt-0">
								<div className=" ">
									<h5 className="card-title-16 pt-2 ">
										SRI LALITHA ENTERPRISES INDUSTRIES PVT.
										LTD
									</h5>
									<p className="card-title-14 pt-2 mb-0">
										Valuthimmapuram Road, PEDDAPURAM -
										533437, E.G. Dist. - AP
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Phone No.0884-2326661, 62, Mobile
										No.9494127893,
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Email: purchase@sleipl.com,
										lalitharice@gmail.com
									</p>
									<p className="card-title-14 pt-2">
										GSTIN : 37AAKCS3233N1ZX
									</p>
								</div>
								<div className="pt-2">
									<span className="p-1">
										<img
											className="img-fluid p-0"
											src={SLE_logo}
											alt="Logo"
											width="100"
											height="120"
										/>
									</span>
									<h4 className="report-title mb-0">
										SR QUOTATION
									</h4>
									<h5 className="report-title">
										<span className="report-number">
											#{this.props.SR_Q_Doc_report.code}
										</span>
									</h5>
								</div>
							</div>
							<hr className="hr-black-color " />

							<div className="report-body flex-sm-row flex-column mt-0">
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Create By:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.SR_Q_Doc_report
													.createdby?.fullname
											}{" "}
											(
											{
												this.props.SR_Q_Doc_report
													.createdby?.username
											}
											)
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											RFQ Code:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.SR_Q_Doc_report
													.requestforquotation_code
											}
										</p>
									</div>

									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Vendor Name:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.SR_Q_Doc_report
													.vendor?.name
											}
										</p>
									</div>
								</div>
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Total Price:
										</p>
										<p className="report-wrapper-det">
											&#8377;{" "}
											{this.props.SR_Q_Doc_report.total}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Delivery Date:
										</p>
										<p className="report-wrapper-det">
											{moment(
												this.props.SR_Q_Doc_report
													.deliverydate
											).format("DD-MM-YYYY")}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Submited On:
										</p>
										<p className="report-wrapper-det">
											{moment(
												this.props.SR_Q_Doc_report
													.createdon
											).format("DD-MM-YYYY")}
										</p>
									</div>
								</div>
							</div>
							<hr className="hr-black-color " />
							<div className="m-0">
								<Table
									// striped
									bordered
									// hover
									className="mb-0 p-0 table-centered table-color-black">
									<thead className="bg-light text-center">
										<tr>
											<th style={{ width: "5%" }}>
												S.NO
											</th>
											<th style={{ width: "35%" }}>
												Item Name
											</th>
											<th style={{ width: "10%" }}>
												Quantity
											</th>
											<th style={{ width: "10%" }}>
												Item Base Price
											</th>
											<th style={{ width: "5%" }}>
												Item Discount(%)
											</th>
											<th style={{ width: "10%" }}>
												Item Price
												<br />
												<sup>(Discount)</sup>
											</th>
											<th style={{ width: "4%" }}>
												Tax Type (%)
											</th>
											<th style={{ width: "8%" }}>
												Tax Amount
											</th>
											<th style={{ width: "10%" }}>
												Gross Value
											</th>
										</tr>
									</thead>
									<tbody>
										{this.props.SR_Q_Doc_report?.sqitems?.map(
											(item, key) => (
												<tr key={key}>
													<td className="text-center">
														{key + 1}
													</td>
													<td>
														<h5 className="font-size-14 ">
															{
																item?.product
																	?.name
															}
														</h5>
														<p className="mb-0">
															Make :{" "}
															<span className="font-weight-medium">
																{item.make}
															</span>
														</p>
														{/* <p className="mb-0">
                            Description :{" "}
                            <span className="font-weight-medium">
                              {item.description}
                            </span>
                          </p> */}
													</td>

													<td className="text-center">
														{item.qty}{" "}
														{item.unit?.name}
													</td>
													<td className="text-center">
														{item.baseprice}
													</td>
													<td className="text-center">
														{item.discountpercent}%
													</td>
													<td className="text-center">
														{item.price}
														<br />
														<sup>
															({item.discount})
														</sup>
													</td>
													<td className="text-center">
														{parseInt(
															item.taxtype
														) === 1
															? "Inclusive"
															: "Exclusive"}{" "}
														({item.tax.name})
													</td>

													<td className="text-center">
														{item.taxamount}
													</td>
													<td className="text-center">
														{item.gross}
													</td>
												</tr>
											)
										)}
									</tbody>
								</Table>
							</div>
							<hr className="hr-black-color " />
							<Row>
								<Col md={12}>
									<p className="font-weight-bold mb-1 text-black">
										Terms & Conditions:
									</p>
									<span className="ml-4 text-black">
										{this.props.SR_Q_Doc_report.terms}
									</span>
								</Col>
							</Row>
							{this.props.SR_Q_Doc_report.description != null && (
								<>
									<hr className="hr-black-color " />
									<Row>
										<Col md={12}>
											<p className="font-weight-bold mb-1 text-black">
												Other Details:
											</p>
											<span className="ml-4 text-black">
												{
													this.props.SR_Q_Doc_report
														.description
												}
											</span>
										</Col>
									</Row>
								</>
							)}
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}
	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						{this.props.loading && (
							<LoadingModel OpenModel={this.props.loading} />
						)}
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom no-print ">
										<Link
											to="#"
											onClick={() =>
												this.props.history.goBack()
											}
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										{/* {this.props.SRQuotationPdf ? (
                      <Link
                        to={"/Quotation/" + this.props.match.params.id}
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    ) : (
                      <Link
                        to="/qreport"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    )} */}

										<div className="float-right">
											<div className="d-inline-block ">
												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														this.getPDFReport()
													}>
													<i className="ri-file-excel-2-line"></i>
													<span className="d-none d-inline-block ml-1">
														PDF
													</span>
												</Button>

												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														window.print()
													}>
													<i className="mdi  mdi-printer"></i>
													<span className="d-none d-inline-block ml-1">
														Print
													</span>
												</Button>
											</div>
										</div>
									</CardHeader>
									<CardBody
										className="pt-1 mr-auto mx-auto"
										id="toPdf">
										{this.reportBody()}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { SR_Q_Doc_report, SRQuotationPdf, loading } = state.reports;
	return {
		SR_Q_Doc_report,
		SRQuotationPdf,
		loading,
	};
};

export default connect(mapStatetoProps, {
	getSRQDocReport,
})(QuotationReportDocument);
